import { render, staticRenderFns } from "./Oto.vue?vue&type=template&id=e82a76c6&scoped=true&"
import script from "./Oto.vue?vue&type=script&lang=js&"
export * from "./Oto.vue?vue&type=script&lang=js&"
import style0 from "./Oto.vue?vue&type=style&index=0&id=e82a76c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82a76c6",
  null
  
)

export default component.exports